import React from 'react';
import JavascriptOperatorsAssignment from './JavascriptOperatorsAssignment.jsx';
import JavascriptOperatorsArithmetic from './JavascriptOperatorsArithmetic.jsx';
import JavascriptOperatorsComparison from './JavascriptOperatorsComparison.jsx';
import JavascriptOperatorsLogical from './JavascriptOperatorsLogical.jsx';
import JavascriptOperatorsBitwise from './JavascriptOperatorsBitwise.jsx';
import JavascriptOperatorsReference from './JavascriptOperatorsReference.jsx';
import JavascriptOperatorsPrecedence from './JavascriptOperatorsPrecedence.jsx';

export default function JsOperators() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Operators</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/operators/assignment' className='underline'>JS Assignment</a></li>
<li><a href='/javascript/operators/arithmetic' className='underline'>JS Arithmetic</a></li>
<li><a href='/javascript/operators/comparison' className='underline'>JS Comparison</a></li>
<li><a href='/javascript/operators/logical' className='underline'>JS Logical Operators</a></li>
<li><a href='/javascript/operators/bitwise' className='underline'>JS Bitwise Operators</a></li>
<li><a href='/javascript/operators/reference' className='underline'>JS Operator Reference</a></li>
<li><a href='/javascript/operators/precedence' className='underline'>JS Operator Precedence</a></li>
      </ul>
    </div>
  );
}
